import { render, staticRenderFns } from "./Cabecera.vue?vue&type=template&id=c8172614&"
import script from "./Cabecera.vue?vue&type=script&lang=js&"
export * from "./Cabecera.vue?vue&type=script&lang=js&"
import style0 from "./Cabecera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports